import React from 'react';
import { useAppSelector } from '../data/store';
import Preloader from '../../../../ui/svg/common/preloader';
import SearchItem from './search-item';
const SearchResults = () => {

    const filtered = useAppSelector(store => store.root.filtered);
    const isLoading= useAppSelector(store => store.root.isLoading);

    return (
        <div className="lg:flex lg:items-center lg:justify-center">
            <div className="w-full text-sm md:text-base pt-4 md:pt-6 xl:pt-8 pb-0">

                {
                    isLoading &&
                    <div className="flex items-center justify-center mb-4">
                        <Preloader width="25px" height="25px" color="#4f4f4f"/>
                        <div className="ml-4">Fetching Results…</div>
                    </div>
                }

                {
                    !isLoading && (filtered.length === 0) &&
                    <div className="w-full text-center">No results were found.</div>
                }

                {
                    !isLoading && (filtered.length > 0) &&
                    <ul>
                        {
                            filtered.map((filterItem, index) => {
                                return (
                                    <li key={filterItem.documentUrlPath}>
                                        <SearchItem
                                            filterItem={filterItem}
                                            position={index}
                                            isLast={index === filtered.length - 1}
                                        />
                                    </li>
                                )
                            })
                        }
                    </ul>
                }

            </div>
        </div>
    )
};

export default SearchResults;